export default __webpack_public_path__ + "static/media/icone-artigos-pessoais.84c00a9b.png";